import * as React from "react";
import { SVGProps } from "react";

const Cybervein = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 1000 1000"
    {...props}
  >
    <style>{".st1{fill:#1e90ff}.st5{fill:indigo}"}</style>
    <path
      id="SVGID_1_"
      fill="#1e0b49"
      d="M500 0c276.1 0 500 223.9 500 500s-223.9 500-500 500S0 776.1 0 500 223.9 0 500 0z"
    />
    <g id="Layer_2_1_">
      <g id="Layer_1-2">
        <path
          d="M324.6 400c22.1-37.6 57.5-59.9 88.6-59.3l12.6-21.3c21.7-36.9 14.2-81.9-16.8-100.1s-73.9-2.8-95.7 33.9l-12.5 21.3c15.6 26.9 13.2 68.5-8.9 106.3s-57.5 59.9-88.6 59.3l-12.6 21.3c-21.7 36.9-14.2 81.9 16.8 100.1 30.9 18.2 73.9 2.9 95.7-33.9l12.5-21.3c-15.6-26.9-13.2-68.7 8.9-106.3z"
          className="st1"
        />
        <linearGradient
          id="SVGID_2_"
          x1={281.243}
          x2={336.862}
          y1={440.084}
          y2={344.911}
          gradientTransform="matrix(1 0 0 -1 0 1000)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.21} stopColor="#1e90ff" />
          <stop offset={1} stopColor="indigo" />
        </linearGradient>
        <path
          fill="url(#SVGID_2_)"
          d="M292 615.9c-22.1-37.6-57.5-59.9-88.6-59.3l-12.6-21.3c-21.7-36.9-14.2-81.9 16.8-100.1s73.9-3 95.7 33.9l12.5 21.3c-15.6 26.9-13.2 68.5 8.9 106.3 22.2 37.8 57.5 59.9 88.6 59.3l12.6 21.3c21.7 36.9 14.2 81.9-16.8 100.1-30.9 18.2-73.9 3-95.7-33.9l-12.5-21.3c15.5-26.9 13.1-68.7-8.9-106.3z"
        />
        <linearGradient
          id="SVGID_3_"
          x1={-88.404}
          x2={-88.328}
          y1={373.572}
          y2={280.456}
          gradientTransform="matrix(-.8 .47 -.56 -.96 671.48 960.04)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#8b008b" />
          <stop offset={1} stopColor="indigo" />
        </linearGradient>
        <path
          fill="url(#SVGID_3_)"
          d="M543.7 615.9c-22.1-37.6-57.5-59.9-88.6-59.3l-12.6-21.3c-21.7-36.9-14.2-81.9 16.8-100.1s73.9-3 95.6 33.9l12.6 21.3c-15.6 26.9-13.2 68.5 8.9 106.3 22.2 37.8 57.5 59.9 88.6 59.3l12.6 21.3c21.7 36.9 14.2 81.9-16.8 100.1-30.9 18.2-73.9 3-95.7-33.9l-12.5-21.3c15.7-26.9 13.4-68.7-8.9-106.3z"
        />
        <linearGradient
          id="SVGID_4_"
          x1={847.648}
          x2={838.74}
          y1={823.159}
          y2={730.995}
          gradientTransform="matrix(.8 .47 .56 -.96 -425.21 960.04)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#8b008b" />
          <stop offset={1} stopColor="indigo" />
        </linearGradient>
        <path
          fill="url(#SVGID_4_)"
          d="M701.1 619.6c22.1-37.5 57.5-59.9 88.6-59.3l12.6-21.3c21.7-36.9 14.2-81.9-16.8-100.1s-73.9-2.9-95.7 33.9l-12.5 21.3c15.6 26.9 13.2 68.5-8.9 106.3-22.2 37.8-57.5 59.9-88.6 59.3L567.2 681c-21.7 36.9-14.2 81.9 16.8 100.1s73.9 2.9 95.7-33.9l12.5-21.3c-15.8-27-13.2-68.8 8.9-106.3z"
        />
        <path
          d="M371.9 205c-41.9 0-75.8 34.5-74.8 76.6.9 39.7 33.3 72 73 73 42.1 1 76.6-32.9 76.6-74.8 0-41.3-33.5-74.8-74.8-74.8z"
          className="st1"
        />
        <path
          d="M371.9 644c-41.9 0-75.7 34.5-74.7 76.7 1 40.5 34.6 73.1 75.1 72.9 41.1-.2 74.4-33.5 74.5-74.7 0-41.3-33.5-74.9-74.9-74.9z"
          className="st5"
        />
        <path
          d="M622.6 205c-41.9 0-75.8 34.5-74.8 76.6.9 39.7 33.3 72 73 73 42.1 1 76.6-32.9 76.6-74.8 0-41.3-33.5-74.8-74.8-74.8z"
          className="st1"
        />
        <path
          d="M622.6 644c-41.9 0-75.8 34.5-74.8 76.6.9 40.5 34.6 73.2 75.1 73 41.1-.2 74.4-33.5 74.5-74.7 0-41.3-33.4-74.8-74.8-74.9z"
          className="st5"
        />
        <path
          fill="#8b008b"
          d="M495.5 424.5c-41.9 0-75.8 34.5-74.8 76.6.9 39.7 33.3 72 73 73 42.1 1 76.6-32.9 76.6-74.8 0-41.3-33.5-74.8-74.8-74.8zm253.5 0c-41.9 0-75.8 34.4-74.8 76.6.9 39.7 33.3 72.1 72.9 73 42.1 1 76.6-32.8 76.6-74.7 0-41.4-33.4-74.8-74.7-74.9z"
        />
        <path
          d="M242 424.5c-41.9 0-75.8 34.5-74.8 76.6.9 39.7 33.3 72 73 73 42.1 1 76.6-32.9 76.6-74.8 0-41.3-33.5-74.8-74.8-74.8z"
          className="st1"
        />
      </g>
    </g>
  </svg>
);

export default Cybervein;
